import { render, staticRenderFns } from "./ChatHeaderIcons.vue?vue&type=template&id=1b4179a0&scoped=true&"
import script from "./ChatHeaderIcons.vue?vue&type=script&lang=js&"
export * from "./ChatHeaderIcons.vue?vue&type=script&lang=js&"
import style0 from "./ChatHeaderIcons.vue?vue&type=style&index=0&id=1b4179a0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b4179a0",
  null
  
)

export default component.exports